import { useState } from "react";

const faqItems = [
  {
    q: "Where is the Don Collins Auto Storage San Rafael location?",
    a: "The San Rafael location is on Irwin St. in San Rafael, CA — centrally located in Marin County. It&apos;s convenient for residents of San Rafael, Mill Valley, San Anselmo, Fairfax, Novato, and the broader Marin area. Call (415) 453-9180 for the exact address.",
  },
  {
    q: "Where is the Don Collins Point Richmond storage facility?",
    a: "The Point Richmond location is on Canal Blvd in Point Richmond, CA — approximately 9 miles (15 minutes) from the San Rafael facility, near the Standard Oil Refinery. It serves the East Bay including Berkeley, Oakland, Richmond, and El Cerrito.",
  },
  {
    q: "How far is the Point Richmond location from San Rafael?",
    a: "The Point Richmond facility is approximately 9 miles and 15 minutes from the San Rafael location. Both facilities offer the same secure, fully-alarmed indoor vehicle storage standards, giving Bay Area customers two convenient access points.",
  },
  {
    q: "What cities are near the Don Collins San Rafael storage facility?",
    a: "The San Rafael facility on Irwin St. is convenient for vehicle owners in San Rafael, Mill Valley, Sausalito, Tiburon, Corte Madera, San Anselmo, Fairfax, Novato, Petaluma, and San Francisco — all of Marin County and the North Bay.",
  },
  {
    q: "Is there indoor car storage near me in the East Bay?",
    a: "Yes. Don Collins Auto Storage&apos;s Point Richmond facility on Canal Blvd serves the East Bay with secure, fully-alarmed indoor vehicle storage. Convenient for Berkeley, Oakland, Richmond, El Cerrito, Emeryville, and surrounding East Bay communities.",
  },
  {
    q: "Are drop-offs available at both locations?",
    a: "Yes, drop-off is available at both the San Rafael and Point Richmond facilities. Storage is by appointment only — please call (415) 453-9180 first. Jim Long asks that you call before visiting so he can be ready to provide the best possible service.",
  },
  {
    q: "What are the hours for Don Collins Auto Storage?",
    a: "Storage access is available every day, by appointment only. Please call (415) 453-9180 before visiting. Jim Long emphasizes calling ahead so he can be prepared for your visit — he doesn&apos;t want to miss you.",
  },
];

export default function LocationFAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section
      id="faq"
      className="bg-[#F8F8F8] py-24 lg:py-32"
      itemScope
      itemType="https://schema.org/FAQPage"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <p className="font-sans text-gold text-xs tracking-[0.3em] uppercase font-semibold mb-4">
            Location FAQ
          </p>
          <h2 className="font-serif text-charcoal text-4xl lg:text-5xl font-bold mb-4">
            Directions &amp; Access Questions
          </h2>
          <p className="font-sans text-[#777] text-base">
            Everything about our San Rafael and Point Richmond locations, hours, and access.
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg overflow-hidden"
              style={{ borderLeft: openIdx === idx ? "2px solid #D4AF37" : "2px solid transparent" }}
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <h3
                  className="font-sans text-charcoal text-base font-semibold pr-4 leading-snug"
                  itemProp="name"
                  dangerouslySetInnerHTML={{ __html: item.q }}
                />
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`${
                      openIdx === idx ? "ri-subtract-line text-gold" : "ri-add-line text-gold"
                    } text-lg transition-all duration-200`}
                  ></i>
                </div>
              </button>
              {openIdx === idx && (
                <div
                  className="px-6 pb-5"
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <p
                    className="font-sans text-[#666] text-sm leading-relaxed"
                    itemProp="text"
                    dangerouslySetInnerHTML={{ __html: item.a }}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
